import { ExpandingTextArea } from 'foundations-components/transitional/components/ExpandingTextArea';
import { CharacterCounter } from 'foundations-components/transitional/components/CharacterCounter';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MultilineCharacterCounter = props => {
  const TextAreaComponent = props.textAreaComponent;
  return /*#__PURE__*/_jsx(CharacterCounter, {
    "data-test-id": "kb-character-counter",
    counter: "down",
    label: ({
      count
    }) => count < props.maxLengthWarningThreshold ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(View, {
        borderBlockStartStyle: "solid",
        borderBlockStartWidth: "100",
        borderBlockStartColor: "border-secondary-default",
        inlineSize: "688px",
        textAlign: "right",
        children: count
      })
    }) : null,
    maxLength: props.maxLength,
    onBlur: props.onBlur,
    onChange: props.onChange,
    renderInput: ({
      value,
      onChange,
      onBlur
    }) => /*#__PURE__*/_jsx(TextAreaComponent, {
      "data-test-id": props['data-test-id'],
      disabled: props.disabled,
      inputRef: props.inputRef,
      maxLength: props.maxLength,
      onBlur: onBlur,
      onChange: onChange,
      placeholder: props.placeholder,
      shrink: true,
      styled: false,
      value: value
    }),
    value: props.value
  });
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
MultilineCharacterCounter.defaultProps = {
  textAreaComponent: ExpandingTextArea
};
export default MultilineCharacterCounter;